import './slick.min'

export default class RmSlider {
	constructor(container, fade = false) {
		this.container = container
		this.fade = fade
	}

	init() {
		this.onInit()
		this.onBeforeChange()
		this.onAfterChange()
		this.onClickButton()



		this.container.find('.rm-slider-list').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            initialSlide: 1,
            pauseOnHover: false,
			fade: this.fade,
            prevArrow: $('.rm-slider-prev'),
            nextArrow: $('.rm-slider-next'),
        })
	}

	onInit() {
		this.container.find('.rm-slider-list').on('swipe',() => {
			this.container.find('.rm-slider-list').slick('slickPause')
			this.container.find('.rm-slider-list').off('afterChange')
			this.container.find('.rm-slider-next .circle-countdown .circle').removeClass('running');
		});

		this.container.find('.rm-slider-list').on('init', () => {
            this.container.find('.rm-slider-next .circle-countdown .circle').addClass('running');
        })
	}

	onBeforeChange() {
		this.container.find('.rm-slider-list').on('beforeChange', (event, slick, currentSlide) => {
            const currentImage = currentSlide + 1 >= 10 ? currentSlide + 1 : `0${currentSlide + 1}`
            this.container.find('.current-step').text(currentImage)

            if (this.container.find('.rm-slider-next .circle-countdown .circle').hasClass('running')) {
                this.container.find('.rm-slider-next .circle-countdown .circle').removeClass('running');
            }
        })
	}

	onAfterChange() {
		this.container.find('.rm-slider-list').on('afterChange', () => {
            this.container.find('.rm-slider-next .circle-countdown .circle').addClass('running');
        })
	}

	onClickButton() {
		this.container.find('.rm-slider-nav button').on('click', () => {
            this.container.find('.rm-slider-next .circle-countdown .circle').removeClass('running');
            this.container.find('.rm-slider-list').off('afterChange')
            this.container.find('.rm-slider-list').slick('slickPause')
        })
	}
}